import { observer } from "mobx-react-lite";

import { EndpointTitle } from "./EndpointTitle";
import { getShowModel } from "../../constants/Endpoints";
import { endpointStore } from "../../utils/mobx/EndpointStore";
import ModelInfo from "../model/ModelInfo";

const DetailHeader = () => {
  const { endpointType } = endpointStore;
  return (
    <div className="flex flex-col gap-4 p-4">
      <EndpointTitle />
      {getShowModel(endpointType) && <ModelInfo />}
    </div>
  );
};

export default observer(DetailHeader);
